import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hook";
import {
  isMailValid,
  isNull,
  isLengthValid,
} from "../../utils/inputValidation";
import {
  Input,
  Textarea,
  Button,
  FormField,
  SpaceBetween,
  Form,
  Container,
  Link,
  Box,
  ColumnLayout,
  Header,
  Badge,
} from "@cloudscape-design/components-themed";
import { LABELS } from "../notice/constants";
import {
  useGetNoticeQuery,
  usePutNoticeUpdateMutation,
} from "../../features/api";
import { Notice, NoticeUpdate } from "../../features/api-interfaces";
import { getMessage } from "../..//features//error/messages";
import { openHelpPanel } from "../layouts/help-panel-slice";
import { COMMON_LABELS } from "../default-constants";
import { showModal } from "../UI/modal/modal-slice";
import { formatYearDate } from "../../utils/format";
/*
通知マスタ更新画面
 */
const UpdateForm = () => {
  const { id } = useParams();
  const noticeId = id as string;
  const { data, isFetching } = useGetNoticeQuery(Number(noticeId));
  const noticeData = data as Notice;
  const dispatch = useAppDispatch();
  const [updateNotice] = usePutNoticeUpdateMutation();
  const navigator = useNavigate();
  //入力チェックエラーメッセージ
  const [fromNameErrorMsg, setFromNameErrorMsg] = useState("");
  const [fromAddressErrorMsg, setFromAddressErrorMsg] = useState("");
  const [ccErrorMsg, setCcErrorMsg] = useState("");
  const [bccErrorMsg, setBccErrorMsg] = useState("");
  const [subjectErrorMsg, setSubjectErrorMsg] = useState("");
  const [mailErrorMsg, setMailErrorMsg] = useState("");
  //初期値
  const [condition, setCondition] = useState("");
  const [usage, setUsage] = useState("");
  const [fromName, setFromName] = useState("");
  const [fromAddress, setFromAddress] = useState("");
  const [to, setTo] = useState("");
  const [cc, setCc] = useState("");
  const [bcc, setBcc] = useState("");
  const [subject, setSubject] = useState("");
  const [mail, setMail] = useState("");
  const [lastUpdateDate, setLastUpdateDate] = useState("");
  const [lastUpdateBy, setLastUpdateBy] = useState("");
  const [availableParameter, setAvailableParameter] = useState("");
  const [changeFlag, setChangeFlag] = useState(false);

  useEffect(() => {
    if (!isFetching) {
      setCondition(noticeData.conditionName);
      setUsage(noticeData.conditionUseUsage);
      setFromName(noticeData.fromName);
      setFromAddress(noticeData.fromAddress);
      setTo(noticeData.toAddress);
      setCc(noticeData.ccAddress);
      setBcc(noticeData.bccAddress);
      setSubject(noticeData.subject);
      setMail(noticeData.emailBody);
      setLastUpdateDate(formatYearDate(noticeData.updatedAt));
      setLastUpdateBy(noticeData.updatedBy);
      setAvailableParameter(noticeData.availableParameter);
    }
  }, [isFetching, data, noticeData]);

  //  表示名入力チェック 100文字以内
  const handleFromNameOnChange = (fromName: string) => {
    if (isNull(fromName)) {
      setFromNameErrorMsg(
        getMessage("KGRERR023", LABELS.NOTICE_FROM_NAME).label
      );
      return false;
    } else if (!isLengthValid(fromName, 100)) {
      setFromNameErrorMsg(getMessage("KGRERR058", 100).label);
      return false;
    } else {
      setFromNameErrorMsg("");
      setChangeFlag(true);
      return true;
    }
  };
  //  アドレス入力チェック 100文字以内 メールアドレスの形式チェック
  const handleFromAddressOnChange = (fromAddress: string) => {
    if (isNull(fromAddress)) {
      setFromAddressErrorMsg(
        getMessage("KGRERR023", LABELS.NOTICE_FROM_ADDRESS).label
      );
      return false;
    } else if (!isLengthValid(fromAddress, 100)) {
      setFromAddressErrorMsg(getMessage("KGRERR058", 100).label);
      return false;
    } else if (!isMailValid(fromAddress)) {
      setFromAddressErrorMsg(getMessage("KGRERR025").label);
      return false;
    } else {
      setFromAddressErrorMsg("");
      setChangeFlag(true);
      return true;
    }
  };
  // cc入力チェック 半角文字列 500文字以内 メールアドレスの形式チェック カンマ区切り
  const handleCcOnChange = (cc: string) => {
    if (isNull(cc)) {
      setCcErrorMsg(getMessage("KGRERR023", LABELS.NOTICE_CC).label);
      return false;
    } else if (!isLengthValid(cc, 500)) {
      setCcErrorMsg(getMessage("KGRERR058", 500).label);
      return false;
    } else if (!cc.split(",").every(isMailValid)) {
      setCcErrorMsg(getMessage("KGRERR025").label);
      return false;
    } else {
      setCcErrorMsg("");
      setChangeFlag(true);
      return true;
    }
  };
  //  bcc入力チェック 半角文字列 500文字以内 メールアドレスの形式チェック カンマ区切り
  const handleBccOnChange = (bcc: string) => {
    if (isNull(bcc)) {
      setBccErrorMsg(getMessage("KGRERR023", LABELS.NOTICE_BCC).label);
      return false;
    } else if (!isLengthValid(bcc, 500)) {
      setBccErrorMsg(getMessage("KGRERR058", 500).label);
      return false;
    } else if (!bcc.split(",").every(isMailValid)) {
      setBccErrorMsg(getMessage("KGRERR025").label);
      return false;
    } else {
      setBccErrorMsg("");
      setChangeFlag(true);
      return true;
    }
  };
  // subject 件名入力チェック  文字列 100文字以内
  const handleSubjectOnChange = (subject: string) => {
    if (isNull(subject)) {
      setSubjectErrorMsg(getMessage("KGRERR023", LABELS.NOTICE_SUBJECT).label);
      return false;
    } else if (!isLengthValid(subject, 100)) {
      setSubjectErrorMsg(getMessage("KGRERR058", 100).label);
      return false;
    } else {
      setSubjectErrorMsg("");
      setChangeFlag(true);
      return true;
    }
  };
  // mail メール本文入力チェック  文字列 2000文字以内
  const handleMailOnChange = (mail: string) => {
    if (isNull(mail)) {
      setMailErrorMsg(getMessage("KGRERR023", LABELS.NOTICE_MAIL).label);
      return false;
    } else if (!isLengthValid(mail, 2000)) {
      setMailErrorMsg(getMessage("KGRERR058", 2000).label);
      return false;
    } else {
      setMailErrorMsg("");
      setChangeFlag(true);
      return true;
    }
  };
  //入力チェック
  const validateInputs = () => {
    let flag = true;

    if (!handleFromNameOnChange(fromName)) {
      flag = false;
    }
    if (!handleFromAddressOnChange(fromAddress)) {
      flag = false;
    }
    if (!handleCcOnChange(cc)) {
      flag = false;
    }
    if (!handleBccOnChange(bcc)) {
      flag = false;
    }
    if (!handleSubjectOnChange(subject)) {
      flag = false;
    }
    if (!handleMailOnChange(mail)) {
      flag = false;
    }

    return flag;
  };
  const updateOnClick = () => {
    const isInputValid = validateInputs();
    if (isInputValid) {
      const data: NoticeUpdate = {
        id: Number(id),
        fromName: fromName,
        fromAddress: fromAddress,
        ccAddress: cc,
        bccAddress: bcc,
        subject: subject,
        emailBody: mail,
      };
      //アップデート成功の場合、通知マスタ一覧へ遷移
      updateNotice(data).then((result) => {
        if (!("error" in result)) {
          navigator("/notifications");
        }
      });
    }
  };
  const onClickParameterList = function () {
    dispatch(
      openHelpPanel({
        header: <div>{LABELS.NOTICE_PARAMETER}</div>,
        content: (
          <div>
            <p>
              {availableParameter &&
                availableParameter
                  .split(",")
                  .map((item, index) =>
                    index === 0 ? item : [<br key={item} />, item]
                  )}
            </p>
          </div>
        ),
      })
    );
  };
  const returnToNotice = () => {
    if (!changeFlag) {
      navigator("/notifications");
    } else {
      dispatch(
        showModal({
          title: COMMON_LABELS.TITLES.DL,
          content: COMMON_LABELS.CONTENTS.PAGE_MOVE_CONFIRM,
          positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
          negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
          positiveFn: () => {
            navigator("/notifications");
          },
        })
      );
    }
  };
  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <Form>
        <SpaceBetween size="l">
          <Container
            header={
              <Header
                variant="h3"
                actions={
                  <SpaceBetween direction="horizontal" size="xs">
                    {lastUpdateDate || lastUpdateBy ? (
                      <Badge color="green">
                        {LABELS.NOTICE_LAST_UPDATED_BY}
                        {lastUpdateBy}/{LABELS.NOTICE_LAST_UPDATED_DATE}
                        {lastUpdateDate}
                      </Badge>
                    ) : (
                      <></>
                    )}
                  </SpaceBetween>
                }
              ></Header>
            }
          >
            <SpaceBetween size="m">
              <SpaceBetween direction="horizontal" size="l">
                <FormField label={LABELS.NOTICE_ID} stretch={true}>
                  <Input value={noticeId} readOnly />
                </FormField>
              </SpaceBetween>
              <FormField label={LABELS.NOTICE_CONDITION} stretch={true}>
                <ColumnLayout columns={2}>
                  <Input
                    value={condition}
                    onChange={(event) => setCondition(event.detail.value)}
                    readOnly
                  />
                </ColumnLayout>
              </FormField>
              <FormField label={LABELS.NOTICE_USAGE} stretch={true}>
                <ColumnLayout columns={2}>
                  <Input
                    value={usage}
                    onChange={(event) => setUsage(event.detail.value)}
                    readOnly
                  />
                </ColumnLayout>
              </FormField>
              <ColumnLayout columns={2}>
                <FormField
                  label={
                    <SpaceBetween direction="horizontal" size="xs">
                      <Box variant="strong">{LABELS.NOTICE_FROM_NAME}</Box>
                      <Box variant="small" color="text-status-error">
                        {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                      </Box>
                    </SpaceBetween>
                  }
                  stretch={true}
                  constraintText="100文字以内"
                  errorText={fromNameErrorMsg}
                >
                  <Input
                    value={fromName}
                    onChange={(event) => {
                      setFromName(event.detail.value);
                      handleFromNameOnChange(event.detail.value);
                    }}
                    ariaRequired
                  />
                </FormField>
                <FormField
                  label={
                    <SpaceBetween direction="horizontal" size="xs">
                      <Box variant="strong">{LABELS.NOTICE_FROM_ADDRESS}</Box>
                      <Box variant="small" color="text-status-error">
                        {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                      </Box>
                    </SpaceBetween>
                  }
                  stretch={true}
                  constraintText="100文字以内"
                  errorText={fromAddressErrorMsg}
                >
                  <Input
                    value={fromAddress}
                    onChange={(event) => {
                      setFromAddress(event.detail.value);
                      handleFromAddressOnChange(event.detail.value);
                    }}
                    ariaRequired
                  />
                </FormField>
              </ColumnLayout>
              <FormField label={LABELS.NOTICE_TO} stretch={true}>
                <ColumnLayout columns={2}>
                  <Input
                    value={to}
                    onChange={(event) => setTo(event.detail.value)}
                    ariaRequired
                    readOnly
                  />
                </ColumnLayout>
              </FormField>
              <FormField
                label={LABELS.NOTICE_CC}
                constraintText="500文字以内"
                errorText={ccErrorMsg}
                stretch={true}
              >
                <Input
                  value={cc}
                  onChange={(event) => {
                    setCc(event.detail.value);
                    handleCcOnChange(event.detail.value);
                  }}
                />
              </FormField>
              <FormField
                label={LABELS.NOTICE_BCC}
                constraintText="500文字以内"
                errorText={bccErrorMsg}
                stretch={true}
              >
                <Input
                  value={bcc}
                  onChange={(event) => {
                    setBcc(event.detail.value);
                    handleBccOnChange(event.detail.value);
                  }}
                />
              </FormField>
              <FormField
                label={
                  <SpaceBetween direction="horizontal" size="xs">
                    <Box variant="strong">{LABELS.NOTICE_SUBJECT}</Box>
                    <Box variant="small" color="text-status-error">
                      {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                    </Box>
                  </SpaceBetween>
                }
                constraintText="100文字以内"
                errorText={subjectErrorMsg}
                stretch={true}
              >
                <ColumnLayout columns={2}>
                  <Input
                    value={subject}
                    onChange={(event) => {
                      setSubject(event.detail.value);
                      handleSubjectOnChange(event.detail.value);
                    }}
                  />
                </ColumnLayout>
              </FormField>
              <FormField
                label={
                  <SpaceBetween direction="horizontal" size="xs">
                    <Box variant="strong">{LABELS.NOTICE_MAIL}</Box>
                    <Box variant="small" color="text-status-error">
                      {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                    </Box>
                    <Link variant="info" onFollow={onClickParameterList}>
                      {LABELS.NOTICE_PARAMETER}
                    </Link>
                  </SpaceBetween>
                }
                errorText={mailErrorMsg}
                stretch={true}
                constraintText="2000文字以内"
              >
                <Textarea
                  value={mail}
                  rows={10}
                  onChange={(event) => {
                    setMail(event.detail.value);
                    handleMailOnChange(event.detail.value);
                  }}
                />
              </FormField>
            </SpaceBetween>
          </Container>
          <ColumnLayout columns={2}>
            <Box float="left">
              <Button formAction="none" variant="link" onClick={returnToNotice}>
                {COMMON_LABELS.BTNS.BACK}
              </Button>
            </Box>
            <Box float="right">
              <Button variant="primary" onClick={updateOnClick}>
                {COMMON_LABELS.BTNS.UPDATE}
              </Button>
            </Box>
          </ColumnLayout>
        </SpaceBetween>
      </Form>
    </form>
  );
};
export default UpdateForm;
